<template>
  <div class="">
    <MobileBanner />
    <GroupTab v-if="showGroupTab"></GroupTab>
    <PhaseTabs v-if="showPhaseTab"></PhaseTabs>

    <div class="container-md page container-fluid">
      <div class="row">
        <div class="col-3 position-relative d-none d-lg-block">
          <div :class="{ fixed: isFixed }">
            <SideMenu :menu="menu[$route.name]" :section="curSection" />
          </div>
        </div>
        <div class="col-12 col-lg-9">
          <router-view v-slot="{ Component }">
            <transition name="fade-transform" mode="out-in">
              <component :is="Component" @setCurSection="setCurSection" />
            </transition>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupTab from '@/components/global/GroupTab.vue';
import PhaseTabs from '@/components/camp-list/PhaseTabs.vue';
import MobileBanner from '@/components/global/MobileBanner.vue';
import SideMenu from '@/components/global/SideMenu.vue';
import { menu } from '@/assets/js/menu';

export default {
  name: 'NormalPage',
  components: {
    MobileBanner,
    SideMenu,
    GroupTab,
    PhaseTabs,
  },
  data() {
    return {
      groupPages: ['Download', 'About', 'CampList', 'CampList2', 'CampList3', 'CampList4', 'CampCourses', 'AboutEn'],
      phasePages: ['CampList', 'CampList2', 'CampList3', 'CampList4'],
      isFixed: true,
      menu,
      curSection: '計畫緣起',
    };
  },
  computed: {
    showGroupTab() {
      return this.groupPages.indexOf(this.$route.name) > -1;
    },
    showPhaseTab() {
      return this.phasePages.indexOf(this.$route.name) > -1;
    },
    key() {
      return this.$route.path;
    },
  },
  methods: {
    setCurSection(section) {
      this.curSection = section;
    },
  },
};
</script>

<style lang="stylus" scoped>
.fixed
  position: sticky !important;
  top: 200px;
  // padding-left: 34px;
</style>
